export interface MenuLinkData {
    id?: number;
    name: string;
    url: string;
    children: MenuLinkData[];
}

export interface MenuLinks {
    catalogLinks: MenuLinkData[];
    otherLinks: MenuLinkData[];
}

interface AbstractMenuProps extends MenuLinks {
    currentCategoryIds?: string[];
    onLoadCatalogLinks: () => JQuery.jqXHR|null;
    onUpdateCatalogLinks: () => void;
}

export default abstract class AbstractMenu<P = {}, T = {}> extends React.Component<P & AbstractMenuProps, T> {

}
